<template>
    <div ref="diagram" data-diagram v-html="html"></div>
</template>
<script setup>
import { ref, onMounted, onBeforeUnmount, watch, computed } from "vue";

const emit = defineEmits(['filter:legend'])
const model = defineModel()
defineProps({
    html: {
        type: String,
        required: true,
        default: '',
    },
});

const diagram = ref(null);

const targets = computed(() => diagram.value?.querySelectorAll('[data-legend]'))

watch(model, (value) => {
    // Notify the parent to filter the parts list
    emit('filter:legend', value)

    // Mark active nodes
    targets.value?.forEach((target) => {
        if (target.dataset.legend === model.value) {
            target.setAttribute('data-legend-active', 'true')
        } else {
            target.removeAttribute('data-legend-active')
        }
    })
});

onMounted(() => {
    const targets = diagram.value?.querySelectorAll("[data-legend]");

    const handleClick = (event) => {
        const target = event.target.closest("[data-legend]");
        if (target) {
            const value = target.dataset.legend;
            model.value = model.value === value ? null : value;
        }
    };

    targets.forEach((target) => {
        target.addEventListener('click', handleClick);
    });

    onBeforeUnmount(() => {
        targets.forEach((target) => {
            target.removeEventListener('click', handleClick);
        });
    });
});
</script>

<style>
[data-diagram] {
    [data-legend] {
        cursor: pointer;

        &:hover {
            stroke-width: 1px;
        }
    }

    [data-legend-active] {
        stroke-width: 1px;
        stroke: currentColor;
    }

    &:where(:has([data-legend-active])) [data-legend]:not([data-legend-active]):not(:hover) {
        opacity: 0.5;
    }
}
</style>
